import { render, staticRenderFns } from "./HoldEmpInventory.vue?vue&type=template&id=565efba6"
import script from "./HoldEmpInventory.vue?vue&type=script&lang=js"
export * from "./HoldEmpInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports